"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PivotGroup;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _pivot = _interopRequireDefault(require("./pivot"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Import child components

/**
 * Creates a group of pivot elements
 *
 * @param {Object} props - Component props
 * @param {String} [props.design] - Determines the look of the pivots, default look is 'cards', option for 'slats'
 * @param {Array<Object>} props.pivotList - An array of objects which describe each pivot
 * @param {Integer} [props.selectedIndex] - Index of the selected pivot
 * @returns {Element} - Pivot group
 */
function PivotGroup(props) {
  const {
    design,
    pivotList,
    selectedIndex = -1
  } = props;
  const [index, setIndex] = (0, _react.useState)(selectedIndex);
  (0, _react.useEffect)(() => {
    setIndex(selectedIndex);
  }, [selectedIndex]);
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "navigation",
    className: (0, _classnames.default)('ux-pivot-list', {
      'ux-pivot-cards': design !== 'slats'
    })
  }, pivotList.map((data, i) => /*#__PURE__*/_react.default.createElement(_pivot.default, (0, _extends2.default)({}, data, {
    key: `pivot-list-${i}`,
    onSelected: () => setIndex(i),
    selected: i === index
  }))));
}
PivotGroup.propTypes = {
  /** default is tile buttons meant for tablet/desktop.
   * `slats` which is the default mobile rendering can be forced for tablet/desktop by passing `slats` as design */
  design: _propTypes.default.string,
  /** Array of pivot data structures to generate pivot components */
  pivotList: _propTypes.default.array,
  /**
   * Default selected tile/slat when initially rendered
   * @param {Object} props React props
   * @returns {Error|null} validation
   */
  selectedIndex: props => {
    const {
      selectedIndex,
      pivotList
    } = props;
    if (!(selectedIndex && pivotList)) return null;
    const error = typeof selectedIndex !== 'number' && 'selectedIndex must be a number' || (selectedIndex > pivotList.length - 1 || selectedIndex < -1) && 'selectedIndex is invalid';
    return error ? new Error(error) : null;
  }
};